import { render, staticRenderFns } from "./QSCInspectionQuestion.vue?vue&type=template&id=ffcbdf78&scoped=true&"
import script from "./QSCInspectionQuestion.vue?vue&type=script&lang=js&"
export * from "./QSCInspectionQuestion.vue?vue&type=script&lang=js&"
import style0 from "./QSCInspectionQuestion.vue?vue&type=style&index=0&id=ffcbdf78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcbdf78",
  null
  
)

export default component.exports